import React from 'react'
import { useIntl } from 'react-intl'
import LoanCalculatorContent from './LoanCalculatorContent'
import withAuth from '../../../components/withAuth'
import LoanPage from '../../../components/LoanPage'

const LoanCalculator = () => {
	const { formatMessage } = useIntl()
	return (
		<LoanPage
			page="loan-calculator"
			isFullWidth
			breadcrumbs={[
				{
					label: formatMessage({ id: 'breadcrumbs.calculator' }),
					value: 'loan-calculator',
				},
			]}
		>
			<LoanCalculatorContent />
		</LoanPage>
	)
}

export default withAuth(LoanCalculator)
